<template>
  <DashboardCard
    :title="title"
    :loading="loading"
    :counter="items.length.toString()"
    @refreshCard="$emit('refreshCard')"
    :showActionIcon="showActionIcon"
    :showCounter="showCounter"
  >
    <v-list class="pa-0" v-if="items.length">
      <template v-for="(item, index) in items">
        <v-list-tile :key="item[itemKey]">
          <v-flex
            :xs12="!item[itemAvatar] && !item[itemChip] && !item[itemIcon] && !itemAction"
            :xs8="item[itemAvatar] || item[itemChip] || item[itemIcon]"
            :xs10="itemAction"
          >
            <v-list-tile-content :class="textStyle">
              <v-list-tile-title class="text-truncate">
                  <router-link
                    class="text-link"
                    :to="itemLink(item)"
                    :class="{ 'caption': $vuetify.breakpoint.xsOnly }"
                  >{{ item[itemText] }}</router-link>
                </v-list-tile-title>
            </v-list-tile-content>
          </v-flex>
          <!-- Avatar -->
          <v-flex xs4 v-if="item[itemAvatar] && $vuetify.breakpoint.mdAndUp" class="text-truncate text-xs-center" pa-0>
            <v-tooltip
              v-for="avatar of item[itemAvatar].split(';')"
              :key="avatar"
              bottom
            ><v-chip
              slot="activator"
              color="primary"
              dark
            >{{ avatar[0] }}
            </v-chip>
            <span>{{ avatar }}</span>
            </v-tooltip>
          </v-flex>
          <!-- Chip -->
          <v-flex xs4 v-if="item[itemChip] && $vuetify.breakpoint.mdAndUp" class="text-truncate" pa-0>
            <v-chip
              slot="activator"
              color="grey"
              dark
            >{{ item[itemChip] }}
            </v-chip>
          </v-flex>
          <!-- Icon -->
          <v-flex xs4 v-if="item[itemIcon]" class="text-xs-right" pa-0>
            <v-icon>{{ item[itemIcon] }}</v-icon>
          </v-flex>
          <!-- Icon -->
          <v-flex xs2 v-if="itemAction" class="text-xs-right" pa-0>
            <v-tooltip bottom>
              <span>Opções</span>
              <v-menu bottom left slot="activator">
                <v-btn flat icon small slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile 
                    v-for="(action, i) of itemActions"
                    :key="i"
                    @click="$emit(action, item)"
                  >
                    <v-list-tile-title>{{ action }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-tooltip>
          </v-flex>
        </v-list-tile>
        <v-divider
          v-if="index !== items.length - 1"
          :key="index + item[itemText]"
          class="mx-2"
        ></v-divider>
      </template>
    </v-list>
    <div v-else class="body-2 t text-xs-center py-3">Nenhum registro encontrado</div>
  </DashboardCard>
</template>

<script>
import DashboardCard from '@/components/dashboard/DashboardCard';

export default {
  name: 'DashboardCardListLink',
  props: {
    title: {
      type: String,
      default: 'My Title'
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'Descricao'
    },
    itemRoute: {
      type: String,
      default: ''
    },
    itemKey: {
      type: String,
      default: ''
    },
    itemAvatar: {
      type: String,
      default: 'Avatar'
    },
    itemChip: {
      type: String,
      default: 'Chip'
    },
    itemIcon: {
      type: String,
      default: ''
    },
    itemAction: {
      type: Boolean,
      default: false
    },
    itemActions: {
      type: Array,
      default: () => []
    },
    textStyle: {
      type: String,
      default: 'body-2'
    },
    showActionIcon: {
      type: Boolean,
      default: true
    },
    showCounter: {
      type: Boolean,
      default: true
    },
  },
  components: {
    DashboardCard
  },
  methods: {
    itemLink(item) {
      if (item.route) return item.route;

      const link = {
        name: this.itemRoute
      };
      if (this.itemKey) link.params = { id: item[this.itemKey] };
      return link;
    }
  }
}
</script>

<style>

</style>